// extracted by mini-css-extract-plugin
export default {"version":"AboutPane_version__iVJbU","logo":"AboutPane_logo__ynjeC","wrapper":"AboutPane_wrapper__hz09F"};